// Reusable parent-company ownership statement.
// Standard wording is fixed ("An AMS Venture Holdings Inc. company.") so this
// component can be reused across other AMS Venture Holdings subsidiary websites.
export default function ParentCompanyNotice({ className = "" }) {
  return (
    <p
      data-testid="parent-company-notice"
      className={`text-sm text-muted-foreground ${className}`}
    >
      An{" "}
      <a
        href="https://amsventureholdings.com"
        data-testid="ams-parent-link"
        className="font-medium text-white/70 underline decoration-white/20 underline-offset-4 transition-colors hover:text-white hover:decoration-brand"
      >
        AMS Venture Holdings Inc.
      </a>{" "}
      company.
    </p>
  );
}
